import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function AmlHoursTab() {
  const { hourSettings, updateAmlHours } = useSettingsStore()
  const aml = hourSettings.aml

  return (
    <div className="space-y-6">
      {/* Base Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Base Setup</h4>
        <HourConfigField
          label="AML Base Setup"
          value={aml.baseSetup}
          onChange={(v) => updateAmlHours('baseSetup', v)}
          description="Initial AML configuration"
        />
      </div>

      {/* AML Levels */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">AML Levels</h4>
        <HourConfigField
          label="Standard Level"
          value={aml.standardLevel}
          onChange={(v) => updateAmlHours('standardLevel', v)}
          description="Basic AML screening"
        />
        <HourConfigField
          label="Enhanced Level"
          value={aml.enhancedLevel}
          onChange={(v) => updateAmlHours('enhancedLevel', v)}
          description="Enhanced due diligence"
        />
      </div>

      {/* PEP Levels */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">PEP Screening Levels</h4>
        <HourConfigField
          label="PEP Level 1"
          value={aml.pepLevel1}
          onChange={(v) => updateAmlHours('pepLevel1', v)}
          description="Heads of State, Government Ministers"
        />
        <HourConfigField
          label="PEP Level 2"
          value={aml.pepLevel2}
          onChange={(v) => updateAmlHours('pepLevel2', v)}
          description="Senior officials, Diplomats"
        />
        <HourConfigField
          label="PEP Level 3"
          value={aml.pepLevel3}
          onChange={(v) => updateAmlHours('pepLevel3', v)}
          description="Mid-level officials"
        />
        <HourConfigField
          label="PEP Level 4"
          value={aml.pepLevel4}
          onChange={(v) => updateAmlHours('pepLevel4', v)}
          description="Local government officials"
        />
      </div>

      {/* Additional Features */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Additional Features</h4>
        <HourConfigField
          label="Ongoing Monitoring"
          value={aml.ongoingMonitoring}
          onChange={(v) => updateAmlHours('ongoingMonitoring', v)}
          description="Continuous AML monitoring setup"
        />
        <HourConfigField
          label="Custom Sanctions Lists"
          value={aml.customSanctions}
          onChange={(v) => updateAmlHours('customSanctions', v)}
          description="Custom sanctions list configuration"
        />
        <HourConfigField
          label="Custom Watchlists"
          value={aml.customWatchlists}
          onChange={(v) => updateAmlHours('customWatchlists', v)}
          description="Custom watchlist configuration"
        />
        <HourConfigField
          label="Vendor Integration"
          value={aml.vendorIntegration}
          onChange={(v) => updateAmlHours('vendorIntegration', v)}
          description="Non-FrankieOne vendor setup"
        />
      </div>

      {/* Advanced Screening */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Advanced Screening</h4>
        <HourConfigField
          label="Sanctions Screening"
          value={aml.sanctionsScreening}
          onChange={(v) => updateAmlHours('sanctionsScreening', v)}
          description="Sanctions screening configuration (OFAC, UN, EU, etc.)"
        />
        <HourConfigField
          label="Adverse Media Screening"
          value={aml.adverseMediaScreening}
          onChange={(v) => updateAmlHours('adverseMediaScreening', v)}
          description="Adverse media screening setup"
        />
        <HourConfigField
          label="Additional Watchlists"
          value={aml.additionalWatchlists}
          onChange={(v) => updateAmlHours('additionalWatchlists', v)}
          description="Law enforcement, regulatory, insolvency watchlists"
        />
        <HourConfigField
          label="Batch Processing"
          value={aml.batchProcessing}
          onChange={(v) => updateAmlHours('batchProcessing', v)}
          description="Batch AML screening setup"
        />
        <HourConfigField
          label="Vendor-Specific Features"
          value={aml.vendorSpecificSetup}
          onChange={(v) => updateAmlHours('vendorSpecificSetup', v)}
          description="ComplyAdvantage, Refinitiv, Dow Jones specific config"
        />
        <HourConfigField
          label="Aging Setup"
          value={aml.agingSetup}
          onChange={(v) => updateAmlHours('agingSetup', v)}
          description="AML aging/re-screening configuration"
        />
      </div>
    </div>
  )
}
